import React from 'react';
import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

interface Props {
  label: string;
  handleClose: VoidFunction;
}

export const DialogHeader = ({ label, handleClose }: Props) => (
  <DialogTitle>
    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="h5">{label}</Typography>

      <IconButton size="small" aria-label="Close" onClick={handleClose}>
        <Close style={{ color: '#000000' }} />
      </IconButton>
    </Box>
  </DialogTitle>
);
